<template>
  <div v-if="isLoggedIn" class="avatar-wrapper">
    <a href="#"  slot="activator" @click.stop.prevent="clickedLogOut()" title="Logout">
      <avatar :username="team.teamName" :size="40" :src="team.imageUrl" :title="'Logout'">
      </avatar>
    </a>
    <div class="points">
      {{ userScore }} pts
    </div>
    <v-layout row justify-center style="position: relative;">
      <v-dialog v-model="dialog" lazy absolute>
        <v-card>
          <v-card-title>
            <div class="headline">Are you sure you want to logout?</div>
          </v-card-title>
          <v-card-text>Your team will be logged out from the ongoing game</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="green--text darken-1" flat="flat" @click.native="dialog = false">No</v-btn>
            <v-btn class="green--text darken-1" flat="flat" @click.native="logout()">Yes, please</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>


</template>
<script>
  import {mapGetters} from 'vuex'
  import Avatar from 'vue-avatar'

  const getters = mapGetters([
    'team',
    'userScore',
    'isLoggedIn'
  ])

  export default {
    name: 'team-avatar',
    components: {
      'avatar': Avatar,
    },
    computed: {
      ...getters,
    },
    data() {
      return {
        dialog: false
      }
    },
    methods: {
      clickedLogOut() {
        console.log('clickedLogOut log out')
        this.dialog = true
      },
      logout() {
        console.log('Team log out')
        this.dialog = false

        // Emit event up to parent
        this.$emit('logout')
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/single/TeamAvatar.vue